import React from 'react';

import { IPohodnikRouterItem } from '.';

const Print = React.lazy(() => import('@apps/Print'));

const printRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/print/h:id_hiking',
    component: ({
      match: {
        params: { id_hiking },
      },
    }) => <Print id_hiking={+id_hiking} />,
    protected: false,
    title: 'Печать для похода',
  },
  {
    path: '/print',
    component: () => <Print />,
    protected: false,
    title: 'Печать',
  },
];

export default printRoutes;
